import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { EnquiriesService } from "./enquiry.service";
import { EnQuiryManagementResponse, EnquiryAssessmentInfoModel, EnquiryAssessmentInfoReq, EnquiryAssessmentResponseModel, EnquiryAssessmentUpdateReq, EnquiryIdreq, EnquirymanagementReq, FreezeUnFreezeInfoReq, getAllEnquiryInfoReq } from "@gtpl/shared-models/enquiry-management";
import { CommonResponse } from "@gtpl/shared-models/masters";

@ApiTags('enquiries')
@Controller('enquiries')
export class EnquiriesController {
    constructor(
        private enquiriesService: EnquiriesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) {
    }

    @Post('/getAllEnquiriesByStatus')
    async getAllEnquiriesByStatus(@Body() req:EnquiryAssessmentInfoReq): Promise<EnquiryAssessmentResponseModel> {
        try {
            return await this.enquiriesService.getAllEnquiriesByStatus(req);
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(EnquiryAssessmentResponseModel, error);
        }
    }

    @Post('/updateEnquiryAssesmentStatus')
    async updateEnquiryAssesmentStatus(@Body() req:EnquiryAssessmentUpdateReq): Promise<EnquiryAssessmentResponseModel> {
        try {
            return await this.enquiriesService.updateEnquiryAssesmentStatus(req);
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(EnquiryAssessmentResponseModel, error);
        }
    }
    
    @Post('/createEnquiry')
    async createEnquiry(@Body() req:EnquirymanagementReq):Promise<CommonResponse>{
        try{
            return await this.enquiriesService.createEnquiry(req,false)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }
    @Post('/updateEnquiry')
    async updateEnquiry(@Body() req:EnquirymanagementReq):Promise<CommonResponse>{
        try{
            return await this.enquiriesService.createEnquiry(req,true)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getEnquiryNumberDropdown')
    async getEnquiryNumberDropdown(): Promise<CommonResponse> {
        try {
            return await this.enquiriesService.getEnquiryNumberDropdown();
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getEnquiryDropdownForEnquiryAssessment')
    async getEnquiryDropdownForEnquiryAssessment(): Promise<CommonResponse> {
        try {
            return await this.enquiriesService.getEnquiryDropdownForEnquiryAssessment();
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getCostSheetEnquiryNumberDropdown')
    async getCostSheetEnquiryNumberDropdown(): Promise<CommonResponse> {
        try {
            return await this.enquiriesService.getCostSheetEnquiryNumberDropdown();
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getCountryDropdown')
    async getCountryDropdown(): Promise<CommonResponse> {
        try {
            return await this.enquiriesService.getCountryDropdown();
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getDestinationDropdown')
    async getDestinationDropdown(): Promise<CommonResponse> {
        try {
            return await this.enquiriesService.getDestinationDropdown();
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getUnitDropdown')
    async getUnitDropdown(): Promise<CommonResponse> {
        try {
            return await this.enquiriesService.getUnitDropdown();
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }


    @Post('/getEnquiryById')
    async getEnquiryById(@Body() req:EnquiryIdreq): Promise<EnQuiryManagementResponse> {
        try {
            return await this.enquiriesService.getEnquiryById(req);
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(EnQuiryManagementResponse, error);
        }
    }

    @Post('/getAllEnquiriesInfo')
    async getAllEnquiriesInfo(@Body() req:getAllEnquiryInfoReq):Promise<EnQuiryManagementResponse>{
        try{
            return await this.enquiriesService.getAllEnquiriesInfo(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(EnQuiryManagementResponse, err)
        }
    }

    @Post('/cancelEnquiry')
    async cancelEnquiry(@Body() req:EnquiryAssessmentInfoModel):Promise<EnquiryAssessmentResponseModel>{
        try{
            return await this.enquiriesService.cancelEnquiry(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(EnquiryAssessmentResponseModel, err)
        }
    }

    @Post('/getCountPricesInfo')
    async getCountPricesInfo():Promise<CommonResponse>{
        try{
            return await this.enquiriesService.getCountPricesInfo()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse, err)
        }
    }

    @Post('/getAllEnquiryDetailsById')
    async getAllEnquiryDetailsById(@Body() enqId: EnquiryIdreq):Promise<CommonResponse>{
        try{
            return await this.enquiriesService.getAllEnquiryDetailsById(enqId)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse, err)
        }
    }

    @Post('/getLeadProductInfoModelByEnquiryId')
    async getLeadProductInfoModelByEnquiryId(@Body() req: EnquiryIdreq):Promise<CommonResponse>{
        try{
            return await this.enquiriesService.getLeadProductInfoModelByEnquiryId(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse, err)
        }
    }

    @Post('/getEnqProductConfirmedContainersInfo')
    async getEnqProductConfirmedContainersInfo(@Body() req: EnquiryIdreq):Promise<any>{
        try{
            return await this.enquiriesService.getEnqProductConfirmedContainersInfo(req)
        }catch(err){
            throw err
        }
    }

    @Post('/updateProductSoCreationStatus')
    async updateProductSoCreationStatus(@Body() req: EnquiryIdreq):Promise<any>{
        try{
            return await this.enquiriesService.updateProductSoCreationStatus(req)
        }catch(err){
            throw err
        }
    }

    @Post('/getFreezeUnFreezeEnquiryNumberDropdown')
    async getFreezeUnFreezeEnquiryNumberDropdown(@Body() req:FreezeUnFreezeInfoReq): Promise<CommonResponse> {
        try {
            return await this.enquiriesService.getFreezeUnFreezeEnquiryNumberDropdown(req);
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

}